import { redirectToStandaloneShell } from "@ark/platform/standalone";

redirectToStandaloneShell(
  "meeting",
  window.location,
  import.meta.env.VITE_SHELL_BASE_URL,
);
